var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0402 6.82006L14.2802 2.79006C12.7102 1.69006 10.3002 1.75006 8.79023 2.92006L3.78023 6.83006C2.78023 7.61006 1.99023 9.21006 1.99023 10.4701V17.3701C1.99023 19.9201 4.06023 22.0001 6.61023 22.0001H17.3902C19.9402 22.0001 22.0102 19.9301 22.0102 17.3801V10.6001C22.0102 9.25006 21.1402 7.59006 20.0402 6.82006ZM12.7502 18.0001C12.7502 18.4101 12.4102 18.7501 12.0002 18.7501C11.5902 18.7501 11.2502 18.4101 11.2502 18.0001V15.0001C11.2502 14.5901 11.5902 14.2501 12.0002 14.2501C12.4102 14.2501 12.7502 14.5901 12.7502 15.0001V18.0001Z",
    fill: "url(#paint0_linear_5004_3651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5004_3651",
    x1: 8.7167,
    y1: -2.78502,
    x2: 26.4224,
    y2: 10.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16E2EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.e3213b94571d9d8d5b0ccd6dee304243.svg";
export { ForwardRef as ReactComponent };